// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__27Q6X","inputDescription":"styles_inputDescription__3O7Mg"};